import { useQuery, useQueryClient } from 'react-query';

import type { IProperty } from 'src/services/api/properties/types';
import { queryKeys } from 'src/services/api/constants';
import { apiClient } from 'src/services/api/client';
import { GET_PROPERTIES_PATH } from 'src/services/api/properties/constants';

type IGetPropertiesOptions<TSelected = IProperty[]> = {
    disabled?: boolean;
    select?: (data: IProperty[]) => TSelected;
}

export type IGetPropertiesResponse = {
    properties: Array<IProperty>;
}

export const useProperties = <TSelected = IProperty[]>(options?: IGetPropertiesOptions<TSelected>) => {
    const queryClient = useQueryClient();

    return useQuery(
        [queryKeys.properties],
        async () => {
            const res = await apiClient(GET_PROPERTIES_PATH).json<IGetPropertiesResponse>();
            return res.properties;
        }, {
            enabled: !options?.disabled,
            select: options?.select,
            onSuccess: (data) => {
                if (Array.isArray(data)) {
                    (data as IProperty[]).forEach((property) => {
                        queryClient.setQueryData<IProperty>([queryKeys.properties, property.id], property);
                    });
                }
            },
        }
    );
};
